import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import mitt from 'mitt';
import Axios from 'axios';
import { marked } from 'marked';

// import { setupCache } from 'axios-cache-interceptor';
import SvgIcon from '@/components/ui/SvgIcon.vue';
import Link from '@/components/ui/Link.vue';
import Button from '@/components/ui/Button.vue';
import Loading from '@/components/ui/Loading.vue';
import Content from '@/components/ui/Content.vue';

const emitter = mitt();
// const ajax = setupCache(Axios.create({
//     baseURL: window.globals.api_url,
//     withCredentials: true,
// })); 

const renderer = (str) => {
    if (typeof str !== 'string') return '';
    return marked(str, { breaks: true });
}

const ajax = Axios.create({
    baseURL: window.globals.api_url,
    withCredentials: true,
});




const isExternal = (url) => {
    // console.log(new URL(url, location.origin).origin, window.globals.home_url);
    const or = new URL(url, location.origin).origin;
    const ur = new URL(window.globals.home_url, location.origin).origin;

    // console.log(or, ur, or.indexOf(ur) === -1)

    if (process.env.NODE_ENV === 'production') {
        return or.indexOf(ur) === -1;
    } else {
        return or.indexOf('http://127.0.0.1:8080') === -1;
    }
};

const updateDocumentTitle = (title) => {
    document.title = window.globals.name + ' — ' + title;

    setTimeout(() => {
        
        const uls = document.querySelectorAll('.ui-enter');

        uls.forEach((ul) => {
            const as = ul.querySelectorAll('a');
            as.forEach((a) => {
                a.addEventListener('click', (e) => {
                    if (e.target.dataset.footnoteRef === '' || e.target.dataset.footnoteBackref === '') {
                        e.preventDefault();

                        const el = document.querySelector(e.target.getAttribute('href'));
                        if (el !== null) el.scrollIntoView({ behavior: 'smooth' });

                        // console.log(el)
                    }
                });
            });
        }); 
    }, 100);

};


const app = createApp(App);

// app.directive('observe-visibility', {
//     beforeMount: (el, binding, vnode) => {
//         vnode.context = binding.instance;
//         ObserveVisibility.bind(el, binding, vnode);
//     },

//     update: ObserveVisibility.update,
//     unmounted: ObserveVisibility.unbind,
// });

// app.component('slide-up-down', SlideUpDown);
app.component('ui-link', Link);
app.component('ui-button', Button);
app.component('svg-icon', SvgIcon);
app.component('ui-loading', Loading);
app.component('ui-content', Content);

app.use(store);
app.use(router);

// app.provide('$ajax', ajax);
app.config.globalProperties.$ajax = ajax;
app.config.globalProperties.isExternal = isExternal;
app.config.globalProperties.updateDocumentTitle = updateDocumentTitle;
app.config.globalProperties.marked = renderer;
app.config.globalProperties.EventBus = emitter;
app.mount('#app');

